<template>
  <div>
    <BookedFromPlaceCancelModal
      :dialog="cancelPlaceDialog"
      @confirmed="cancelPlaceDialog = false"
    ></BookedFromPlaceCancelModal>
    <v-card :width="$isTablet ? (windowInnerWidth * 0.6) : (windowInnerWidth * 0.95 - 20)" v-if='roomList.length'
            style='background: #F8F5FD; border: none'>
      <v-card style='background: #F8F5FD;'
        v-for='(item, index) in roomList'
        :key='index' class="pb-1"
      >
        <div style="background: #5B338A" class="pa-4">
          <div class="d-flex flex-column align-center justify-center">
                <span
                  style='color: #CEA2FF; font-size: 22px; font-weight: 700'>
              {{getPlaceApproveStateAliasName(item.state)}}
      </span>
          </div>
          <div v-if="language === 'chinese'" class="prompt mt-4 mb-8" style='color: #FFFFFF'>
            您已成功预定
            {{ item.cityName }}{{ item.cityName === '大连' ? '' : item.buildName
            }}{{ item.roomName === 'King Landing' ? 'King\'s Landing' : item.roomName
            }}，信息如下：
          </div>
          <div v-else class="prompt mt-4 mb-8" style='color: #000000'>
            You have successfully made a reservation
            {{ item.cityValue }}{{ item.cityName === '大连' ? '' : item.buildingValue
            }}{{ item.roomName === 'King Landing' ? 'King\'s Landing' : item.roomName
            }}, The information is as follows:
          </div>
        </div>
        <div class="rounded-lg mt-n8 ma-4 d-flex flex-column" style="background: #FFFFFF">
          <div class="pa-4 d-flex">
            <v-avatar color="primary" size="70" >
              <v-img :src="item.roomImgUrl ? item.roomImgUrl : 'https://myops.accenture.cn/fs_prod/files/MYOPS/20250509/286fe1495c2824f05dad402b6bc58067.png'">
              </v-img>
            </v-avatar>
            <div class="ml-4" style="width: 70%">
              <div class='d-flex align-center justify-space-between'>
                <div class='d-inline-block text-truncate'>
                  <span style='font-size: 18px; color: #000; font-weight: 700'>
                    {{ item.roomName }}
                  </span>
                </div>
              </div>
              <div
                v-if='item.capacity > 1'
                class='text-center mt-2 mr-2'
                style='width: 65px; height: 24px;border-radius: 12px;background: #F8F5FD'>
                <v-icon size='18' color='#803ED3' class='mr-1'>{{ icons.mdiAccountMultipleOutline
                  }}
                </v-icon>
                <span style='font-size: 12px; color: #803ED3'>{{ item.capacity }}</span>
              </div>
              <div v-if="item.standard_services"
                   class='pl-2 image-grid position-absolute' style="bottom: 0">
                <div v-for="(service, index) in splitStandardServices(item.standard_services)"
                     :key="'StandardService-' + index">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-img
                        v-bind="attrs"
                        v-on="on"
                        v-if="getStandardServiceByName(service)"
                        class='mb-1 cursor-pointer' width='20'
                        :src="require(`@/assets/images/standard_services/${getStandardServiceByName(service).iconName}`)">
                      </v-img>
                    </template>
                    <span>{{ getStandardServiceByName(service).name }}</span>
                  </v-tooltip>
                </div>
              </div>
              <div class='mt-1' style='margin-left: -3px'>
                <v-icon size='18' color='#A6A7A9'>{{ icons.mdiMapMarkerRadiusOutline }}</v-icon>
                <span style='color: #A6A7A9; font-size: 14px; font-weight: 400'>
                   {{ item.building }}
            </span>
              </div>
            </div>
          </div>
          <v-divider></v-divider>
          <div class="d-flex pa-4">
            <img style="width: 9px;" class="py-1" :src="require(`@/assets/images/icon-time.png`)">
            <div class="ml-2 d-flex flex-column justify-space-between">
              <div>{{ language === 'chinese' ? '开始时间' : 'Start' }}：<v-chip small class="mr-2">{{ formatDate(item.start) }}</v-chip> <v-chip small>({{ getWeekDayStr(item.start) }})</v-chip></div>
              <div>{{ language === 'chinese' ? '结束时间' : 'End' }}：<v-chip small class="mr-2">{{ formatDate(item.end) }}</v-chip><v-chip small>({{ getWeekDayStr(item.end) }})</v-chip></div>
            </div>
          </div>
          <div :class="['d-flex', 'align-center', 'justify-center', 'mb-4']">
            <v-btn color='primary'
                   :loading='item.loading'
                   :disabled='item.disabled'
                   @click='cancelBooked(item)'
                   small
            >
              {{ language === 'chinese' ? '取消预订' : 'Cancellation' }}
            </v-btn>
          </div>
        </div>
        <div v-if='roomList.length > 1 && index !== roomList.length - 1'
             style='width: 100%; height: 1px; background: #e3e1e1'>
        </div>
      </v-card>
    </v-card>
    <v-card v-else style='background: #F8F5FD; border: none' class='pa-4' :width="$isMobile ? (windowInnerWidth * 0.98) - 20 : 734">
      <div v-if="language === 'chinese'" :class="['mt-3', 'mb-2']" style='font-size: 14px'>
        <div>抱歉，您目前没有已预订的会议室 / 工位， 若您有任何疑问或需要进一步的协助，</div>
        <div>请联系<a href='mailto:GreaterChina.OfficeSupport@accenture.com'>GreaterChina.OfficeSupport@accenture.com</a>,
          谢谢。
        </div>
      </div>
      <div v-else class='mt-3 mb-2' style='font-size: 14px'>
        <div>Sorry, you currently do not have any reserved conference rooms/open workspace.</div>
        <div>If you have any questions or need further assistance,</div>
        <div>please contact <a href='mailto:GreaterChina.OfficeSupport@accenture.com'>GreaterChina.OfficeSupport@accenture.com</a>,
          Thank you.
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import { mdiAccountMultipleOutline, mdiMapMarkerRadiusOutline } from '@mdi/js'
import moment from 'moment'
import { cancelPlacesReservableInfo } from '@/modules/chat/api'
import { getChineseWeekday } from '@/modules/chat/util/ChatBotUtil'
import { StandardServicesMix } from '@/modules/chat/view/chatbot/mixin/commonMixin'
import BookedFromPlaceCancelModal from '@/modules/chat/components/BookedFromPlaceCancelModal'
import { getDateFromDate } from '@/modules/chat/util'

export default {
  components: {
    BookedFromPlaceCancelModal,
  },
  props: {
    roomList: {
      type: Array,
      default: () => [],
    },
    item: {
      type: Object,
      default: () => {
      },
    },
    language: {
      type: String,
      default: 'chinese',
    },
  },
  computed: {
    windowInnerWidth() {
      return window.innerWidth
    },
  },
  mixins: [StandardServicesMix],
  watch: {
    'item.msgId': {
      handler(val) {
        this.roomList.forEach(room => {
          room.disabled = this.item.componentDisabled
        })
      },
      immediate: true,
    },
  },
  data() {
    return {
      icons: {
        mdiMapMarkerRadiusOutline,
        mdiAccountMultipleOutline,
      },
      cancelPlaceDialog: false,
    }
  },
  methods: {
    formatDate(time) {
      return getDateFromDate(time, 'YYYY-MM-DD HH:mm')
    },
    getWeekDayStr(inputDate) {
      if (moment(inputDate, 'YYYY-MM-DD').isValid()) {
        const weekDay = moment(inputDate, 'YYYY-MM-DD').format('dddd')
        return this.language === 'chinese' ? getChineseWeekday(weekDay) : weekDay
      } else {
        return null
      }
    },
    getPlaceApproveStateAliasName(code) {
      if (code === 'Awaiting approval') {
        return this.language === 'chinese' ? '审批中' : 'In approval'
      } else {
        return this.language === 'chinese' ? '已预订' : 'Reserved'
      }
    },
    getTimeFromDate(dateString) {
      return moment(dateString).format('HH:mm')
    },
    getDateFromDate(dateString) {
      return moment(dateString).format('YYYY-MM-DD HH:mm')
    },
    calculateWeekday(inputDate) {
      if (moment(inputDate, 'YYYY-MM-DD').isValid()) {
        const weekDay = moment(inputDate, 'YYYY-MM-DD').format('dddd')
        return this.language === 'chinese' ? getChineseWeekday(weekDay) : weekDay
      } else {
        return null
      }
    },
    async cancelBooked(item) {
      if (item.dataSources === 'place') {
        this.cancelPlaceDialog = true
      } else {
        this.$set(item, 'loading', true)
        const { data: { code, data, msg } } = await cancelPlacesReservableInfo({
          number: item.number,
          roomName: item.roomName,
          roomId: item.roomId,
        })
        this.$set(item, 'loading', false)
        if (code === 200) {
          this.$set(item, 'disabled', true)
          this.$emit('cancelBookingCompletedEmit', { code, ...data })
        } else {
          this.$emit('cancelBookingCompletedEmit', { code, errorMsg: msg, ...data })
        }
      }
    },
  },
}
</script>
<style scoped>
.circle {
  width: 12px;
  height: 12px;
  background: #a100ff;
  border-radius: 50%; /* 关键属性 */
}

/* 图片纵向排列，超过三个图新起一列 */
.image-grid {
  margin-top: 10px;
  margin-left: -5px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(20px, 1fr));
  grid-template-rows: repeat(3, 1fr);
  grid-auto-flow: column;
}

/* 移动端样式 */
@media (max-width: 767px) {
  .prompt {
    font-size: 14px;
  }
  .place-detail {
    font-size: 13px;
  }
}

/* 桌面端样式 */
@media (min-width: 768px) {
  .prompt {
    font-size: 16px;
  }
  .place-detail {
    font-size: 15px;
  }
}
</style>
